export default [{
  path: '/indicacoes',
  component: {
    name: 'indicacoesBase',
    template: '<router-view />',
    meta: {
      resource: 'indicacao',
      action: 'read',
      requiredAuth: true,
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    name: 'indicacoes',
    component: () => import('@/app-modulo/comercial/indicacao/IndicacaoView.vue'),
    meta: {
      resource: 'indicacao',
      action: 'read',
      requiredAuth: true,
      navActiveLink: 'indicacoes',
      pageTitle: 'Cadastro de Indicações',
      breadcrumb: [
        {
          text: 'Indicações',
          to: { name: 'indicacoes' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'novo',
    name: 'novo-indicacao',
    component: () => import('@/app-modulo/comercial/indicacao/shared/components/cadastro/Indicacao.vue'),
    meta: {
      resource: 'indicacao',
      action: 'create',
      requiredAuth: true,
      navActiveLink: 'indicacoes',
      pageTitle: 'Cadastro de Indicações',
      breadcrumb: [
        {
          text: 'Indicações',
          to: { name: 'indicacoes' },
        },
        {
          text: 'Novo',
          to: { name: 'novo-indicacao' },
          active: true,
        },
      ],
    },
  }, {
    path: 'editar/:id',
    name: 'editar-indicacao',
    component: () => import('@/app-modulo/comercial/indicacao/shared/components/cadastro/Indicacao.vue'),
    meta: {
      resource: 'indicacao',
      action: 'update',
      requiredAuth: true,
      navActiveLink: 'indicacoes',
      pageTitle: 'Cadastro de Indicações',
      breadcrumb: [
        {
          text: 'Indicações',
          to: { name: 'indicacoes' },
        },
        {
          text: 'Editar',
          to: { name: 'editar-indicacao' },
          active: true,
        },
      ],
    },
  }],
},
]
